module.exports = __webpack_public_path__ + "static/media/usersIconDashboard.28422505.svg";